import { PublicOfferPage } from '@/page-content/public-offer';
export default PublicOfferPage;